import {
    Box,
    Divider,
    Stack,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    Checkbox,
    useTheme,
    Grid,
  } from '@mui/material';
  import { alpha, styled } from '@mui/material/styles';
  import InputBase from '@mui/material/InputBase';
  import {
    ButtonV3,
    Inputlabel,
    RadioInputV2,
    Select,
  } from 'gf-ui-components-mui-lib';
  import { KeyboardArrowRight } from '@mui/icons-material';
  import SearchIcon from '@mui/icons-material/Search';
  import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
  import { useState } from 'react';
  import { useTableContext } from '../../../context/tableContext';
  import styles from './styles.module.scss';
  import CheckBoxIcon from '../../../assets/svg/CheckboxUnchecked.svg';
  import CheckBoxChecked from '../../../assets/svg/Checkbox.svg';
  import {
    connectorTypes,
    noOfConnectors,
    ocppVersions,
  } from '../../chargerDetails/constants';
  const selectStyles = {
    height: '40px',
    width: '100%',
    fontFamily: 'Poppins',
    fontWeight: 400,
    borderRadius: '4px',
    background: 'white',
    marginBottom: '0px !important',
    boxShadow: '0px 1px 2px 0px #1018280D',
    ':after': {
      border: '0px solid var(--Gray-300, #D0D5DD)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #D0D5DD',
      display: 'flex',
      alignItem: 'center',
      fontWeight: 400,
      justifyContent: 'center',
    },
    '& .MuiSelect-outlined': {
      fontFamily: 'Poppins',
      fontSize: '14px !important',
      fontWeight: 400,
      margin: 0,
    },
  };
  export enum filters {
    vendor = 'Vendor',
    model = 'Model',
    ocppVersion = 'OCPP Version',
    noConnectors = 'No Connectors',
    connectorType = 'Connector Type',
    qrCode = 'QR Code',
    status = 'Status',
    tenant = 'Tenant',
  }
  
  export enum filtersTenant {
    vendor = 'Role',
   
  }
  
  export type FilterType = keyof typeof filters;
  export const RoleFilter = ({  accordian = 0 }: any) => {
    const {
      checked,
      setChecked,
      selectedField,
      setSelectedField,
      filterModel,
      handleModel,
      filterOcpp,
      handleOcpp,
      connectors,
      handleConnectors,
      connectorType,
      handleConnectorType,
      setApplyFilter,
      qrFlag,
      handleQrFlag,
      filterStatus,
      handleFilterStatus,
      filterTenant,
      handleTenant,
      statusList,
      showNext,
      models,
      vendors,
      setApplyEmail,
      setApplyRole
    } = useTableContext();
    const theme = useTheme();
  
  
    const onClickListItem = (filterType: FilterType) => {
      setSelectedField(filterType);
    };
  
    const Search = styled('div')(({ theme }: { theme: any }) => ({
      position: 'relative',
      backgroundColor: alpha(theme.palette.common.white, 1),
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      marginLeft: 0,
      width: '100%',
      borderRadius: '8px',
      border: '1px solid #D0D5DD',
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
      minWidth: '400px',
      fontFamily: 'Poppins',
      [theme.breakpoints.up('sm')]: {
        marginLeft: '16px',
        width: 'auto',
      },
    }));
  
    const SearchIconWrapper = styled('div')(({ theme }: { theme: any }) => ({
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(0, 1),
      },
    }));
  
    const StyledInputBase = styled(InputBase)(({ theme }: { theme: any }) => ({
      color: 'inherit',
      '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(1)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        fontFamily: 'Poppins',
        [theme.breakpoints.up('md')]: {
          width: '60px',
          marginLeft: '10px',
          fontSize: '12px',
        },
      },
    }));
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [searchTerm, setSearchTerm] = useState('');
    const [filtered, setFiltered] = useState([]);
  
    const getState = (selected: string) => {
      switch (selected) {
        case 'connectorType':
          return {
            requiredState: connectorType,
            requiredFunction: (value: any) => handleConnectorType(value),
          };
        case 'status':
          return {
            requiredState: filterStatus,
            requiredFunction: (value: any) => handleFilterStatus(value),
          };
        case 'vendor':
          return {
            requiredState: checked,
            requiredFunction: (value: any) => setChecked(value),
          };
        default:
          return;
      }
    };
  
    const onClickCheckBox = (value: string) => () => {
      const receivedParam: any | undefined = getState(selectedField);
      let requiredState: any;
      let requiredFunction: any;
  
      if (receivedParam) {
        requiredState = receivedParam?.requiredState;
        requiredFunction = receivedParam?.requiredFunction;
      }
  
      const currentIndex = requiredState.indexOf(value);
      const newChecked = [...requiredState];
  
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
  
      requiredFunction(newChecked);
    };
  
    const onClickConnector = (value: any) => () => {
      handleConnectors(value);
    };
  
    const renderFilterList = () => (
      <List
        dense
        disablePadding
        sx={{
          maxWidth: '400px',
          minWidth: '300px',
          height: '500px',
          flex: 1,
          background: '#F9FAFB',
          '& .MuiListItemButton-root.Mui-selected': {
            background: 'rgba(25, 118, 210, 0.08)',
          },
          [theme.breakpoints.down(1441)]: {
            height: '340px',
            minWidth: '250px',
          },
        }}
      >
        {Object.entries(accordian < 4 ? filtersTenant : filters).map(
          ([field, value]: any) => {
            if (showNext) {
              if (value === 'Status') {
                return (
                  <ListItemButton
                    key={field}
                    selected={selectedField === field}
                    disabled={true}
                    onClick={() => onClickListItem(field as FilterType)}
                    sx={{
                      borderBottom: '1px solid #E6E6E6',
                      paddingTop: 0,
                    }}
                  >
                    <ListItemText
                      primary={value}
                      sx={{
                        '& .MuiTypography-root': {
                          fontFamily: 'Poppins',
                          fontSize: '16px',
                          fontWeight: 500,
                          color: '#344054',
                          padding: '12px',
                          [theme.breakpoints.down(1441)]: {
                            padding: '6px',
                          },
                        },
                      }}
                    />
                    <KeyboardArrowRight color='action' />
                  </ListItemButton>
                );
              } else {
                return (
                  <ListItemButton
                    key={field}
                    selected={selectedField === field}
                    onClick={() => onClickListItem(field as FilterType)}
                    sx={{
                      borderBottom: '1px solid #E6E6E6',
                      paddingTop: 0,
                    }}
                  >
                    <ListItemText
                      primary={value}
                      sx={{
                        '& .MuiTypography-root': {
                          fontFamily: 'Poppins',
                          fontSize: '16px',
                          fontWeight: 500,
                          color: '#344054',
                          padding: '12px',
                          [theme.breakpoints.down(1441)]: {
                            padding: '6px',
                          },
                        },
                      }}
                    />
                    <KeyboardArrowRight color='action' />
                  </ListItemButton>
                );
              }
            } else {
              return (
                <ListItemButton
                  key={field}
                  selected={selectedField === field}
                  onClick={() => onClickListItem(field as FilterType)}
                  sx={{
                    borderBottom: '1px solid #E6E6E6',
                    paddingTop: 0,
                  }}
                >
                  <ListItemText
                    primary={value}
                    sx={{
                      '& .MuiTypography-root': {
                        fontFamily: 'Poppins',
                        fontSize: '16px',
                        fontWeight: 500,
                        color: '#344054',
                        padding: '12px',
                        [theme.breakpoints.down(1441)]: {
                          fontSize: '12px',
                          padding: '6px',
                        },
                      },
                    }}
                  />
                  <KeyboardArrowRight color='action' />
                </ListItemButton>
              );
            }
          }
        )}
      </List>
    );
  
    const renderVendorFilterForm = (vendors: any) => {
      const handleSearchChange = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
  
        // Filter options based on user input
        const updateFiltered =
          vendors && isNaN(vendors[0])
            ? vendors?.filter((option: any) =>
              option.toLowerCase().includes(value.toLowerCase())
            )
            : vendors?.map((option: any) => parseInt(option));
        setFiltered(updateFiltered);
      };
  
      return (
        <Box
          sx={{
            bgcolor: 'background.paper',
            '& .MuiBox-root': {
              paddingTop: 0,
            },
          }}
        >
          {selectedField === 'vendor' ? (
            <Search
              sx={{
                minWidth: 0,
                marginTop: '9px',
              }}
            >
              <SearchIconWrapper>
                <SearchIcon
                  sx={{
                    fontSize: '1rem',
                  }}
                />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder='Search'
                inputProps={{ 'aria-label': 'search' }}
                onChange={handleSearchChange}
              />
            </Search>
          ) : null}
  
          <List dense sx={{ width: '100%', padding: '0px' }}>
            {filtered?.length
              ? filtered?.map((value: string) => {
                return (
                  <ListItem key={value} disablePadding>
                    <ListItemButton onClick={onClickCheckBox(value)} dense>
                      <ListItemIcon sx={{ minWidth: 'initial' }}>
                        <Checkbox
                          edge='start'
                          icon={<img src={CheckBoxIcon} alt='' />}
                          checkedIcon={<img src={CheckBoxChecked} alt='' />}
                          checked={
                            selectedField === 'vendor'
                              ? checked.indexOf(value) !== -1
                              : selectedField === 'connectorType'
                                ? connectorType.indexOf(value) !== -1
                                : selectedField === 'status'
                                  ? filterStatus.indexOf(value) !== -1
                                  : false
                          }
                        />
                      </ListItemIcon>
                      <ListItemText primary={value} />
                    </ListItemButton>
                  </ListItem>
                );
              })
              : selectedField === 'status'
                ? []?.map((value: any) => {
                  return (
                    <ListItem
                      key={value?.name}
                      disablePadding
                      sx={{
                        padding: '0px',
                        borderBottom: '1px solid var(--gray-200, #F0F0F0)',
                      }}
                    >
                      <ListItemButton
                        onClick={onClickCheckBox(value?.name)}
                        dense
                        sx={{
                          padding: '12px',
                          [theme.breakpoints.down(1441)]: {
                            padding: '6px',
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{ minWidth: 'initial', paddingLeft: '10px','@media (max-width: 1440px)': {
                            padding: '0px',
                            paddingLeft:'10px'
                          }, }}
                        >
                          <Checkbox
                            edge='start'
                            checked={filterStatus.indexOf(value?.name) !== -1}
                            icon={<img src={CheckBoxIcon} alt='' />}
                            checkedIcon={<img src={CheckBoxChecked} alt='' />}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={value?.name}
                          sx={{
                            '& .MuiTypography-root': {
                              color: 'var(--gray-700, #344054)',
                              fontFamily: 'Poppins !important',
                              fontSize: '12px',
                              fontWeight: 500,
                              lineHeight: '14px',
                            },
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })
                : vendors?.map((value: string) => {
                  return (
                    <ListItem
                      key={value}
                      disablePadding
                      sx={{
                        padding: '0px',
                        borderBottom: '1px solid var(--gray-200, #F0F0F0)',
                      }}
                    >
                      <ListItemButton onClick={onClickCheckBox(value)} dense>
                        <ListItemIcon
                          sx={{
                            minWidth: 'initial', padding: '6px', '@media (max-width: 1440px)': {
                              padding: '0px',
                            },
                          }}
                        >
                          <Checkbox
                            edge='start'
                            icon={<img src={CheckBoxIcon} alt='' />}
                            checkedIcon={<img src={CheckBoxChecked} alt='' />}
                            checked={
                              selectedField === 'vendor'
                                ? checked.indexOf(value) !== -1
                                : selectedField === 'connectorType'
                                  ? connectorType.indexOf(value) !== -1
                                  : false
                            }
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={value}
                          sx={{
                            '& .MuiTypography-root': {
                              color: 'var(--gray-700, #344054)',
                              fontFamily: 'Poppins !important',
                              fontSize: '12px',
                              fontWeight: 500,
                              lineHeight: '14px',
                            },
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
          </List>
        </Box>
      );
    };
  
    const renderNumberOfConnectors = (connectorsArr: any) => {
      return (
        <Box
          sx={{
            bgcolor: 'background.paper',
            height: '100%',
            '& .MuiBox-root': {
              paddingTop: 0,
            },
          }}
        >
          <List dense sx={{ width: '100%', paddingTop: '0px' }}>
            {connectorsArr?.map((item: any, index: number) => {
              return (
                <ListItem
                  key={index}
                  disablePadding
                  sx={{
                    padding: '0px',
                    borderBottom: '1px solid var(--gray-200, #F0F0F0)',
                  }}
                >
                  <ListItemButton
                    onClick={onClickConnector(item)}
                    dense
                    sx={{
                      padding: '12px',
                      '@media (max-width: 1440px)': {
                        padding: '1.5px',
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{ minWidth: 'initial', paddingLeft: '10px' }}
                    >
                      <Checkbox
                        edge='start'
                        icon={<img src={CheckBoxIcon} alt='' />}
                        checkedIcon={<img src={CheckBoxChecked} alt='' />}
                        checked={item === connectors}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item}
                      sx={{
                        '& .MuiTypography-root': {
                          color: 'var(--gray-700, #344054)',
                          fontFamily: 'Poppins !important',
                          fontSize: '12px',
                          fontWeight: 500,
                          lineHeight: '14px',
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      );
    };
  
    const renderDropdown = (
      stateValue: any,
      stateFunction: any,
      labelName: string,
      array?: any
    ) => {
      return (
        <Grid
          sx={{
            width: '290px',
            paddingLeft: '24px',
            paddingTop: '9px',
            [theme.breakpoints.down(1441)]: {
              width: '260px',
            },
          }}
        >
          <Inputlabel
            label={labelName}
            sx={{ fontFamily: 'Poppins', marginBottom: '10px' }}
          />
          <Select
            options={array?.map((item: any) => {
              return {
                label: item,
                value: item,
              };
            })}
            Icon={ExpandMoreIcon}
            name={labelName}
            itemStyles={{
              borderBottom: '1px solid var(--Gray-200, #EAECF0) !important',
              display: 'flex',
              padding: '8px 12px !important',
              justifyContent: 'start',
              alignItems: 'center',
              gap: '6px',
              background: 'var(--Base-White, #FFF)',
              boxShadow: 'none !important',
              minWidth: '0px !important',
              fontFamily: 'Poppins !important',
            }}
            sx={{
              fontSize: '14px',
              minWidth: '163px',
              ...selectStyles,
            }}
            value={stateValue}
            onChange={(e: any) => stateFunction(e.target.value)}
          />
        </Grid>
      );
    };
  
    const renderTenantDropdown = (
      stateValue: any,
      stateFunction: any,
      labelName: string,
      array?: any
    ) => {
      return (
        <Grid
          sx={{
            width: '290px',
            paddingLeft: '24px',
            marginTop: '9px',
            [theme.breakpoints.down(1441)]: {
              width: '260px',
            },
          }}
        >
          <Inputlabel
            label={labelName}
            sx={{ fontFamily: 'Poppins', marginBottom: '10px' }}
          />
          <Select
            options={array?.map((item: any) => {
              return {
                label: item.label,
                value: item.value,
              };
            })}
            Icon={ExpandMoreIcon}
            name={labelName}
            itemStyles={{ fontFamily: 'Poppins !important' }}
            sx={{
              fontSize: '14px',
              minWidth: '163px',
              ...selectStyles,
            }}
            value={stateValue}
            onChange={(e: any) => stateFunction(e.target.value)}
          />
        </Grid>
      );
    };
  
    const renderQrView = (stateValue?: any, stateFunction?: any) => {
      const handleQrSelection = (e: any) => {
        const { id } = e.target;
        stateFunction(id);
      };
      return (
        <div>
          {['Yes', 'No']?.map((item: any, index: any) => {
            return (
              <div key={index} className={`${styles.qrCode}`}>
                <RadioInputV2
                  label={item}
                  id={item}
                  value={qrFlag === item ? item : false}
                  onClick={handleQrSelection}
                  sx={{
                    padding: '12px',
                    fontFamily: 'Poppins',
                    [theme.breakpoints.down(1441)]: {
                      padding: '6px',
                    },
                  }}
                />
              </div>
            );
          })}
        </div>
      );
    };
  
    const renderFilter = () => {
      switch (selectedField) {
        case 'vendor':
          return renderVendorFilterForm(vendors);
        case 'model':
          return renderDropdown(filterModel, handleModel, 'Model', models);
        case 'ocppVersion':
          return renderDropdown(
            filterOcpp,
            handleOcpp,
            'OCPP Version',
            ocppVersions
          );
        case 'noConnectors':
          return renderNumberOfConnectors(noOfConnectors);
        case 'connectorType':
          // return renderInput(connectorType, handleConnectorType);
          return renderVendorFilterForm(connectorTypes);
        case 'qrCode':
          return renderQrView(qrFlag, handleQrFlag);
     
        case 'tenant':
          return renderTenantDropdown(
            filterTenant,
            handleTenant,
            'Tenant',
         
          );
  
        default:
          return <></>;
      }
    };
  
    const resetFilters = () => {
      setChecked([]);
      handleModel('');
      handleOcpp('');
      handleConnectors('');
      handleConnectorType('');
      handleQrFlag('');
      handleFilterStatus('');
      handleTenant('');
    };
  
    return (
      <>
        <Stack
          sx={{
            maxHeight: '477px',
            maxWidth: '800px',
            display: 'flex',
            flex: 1,
            paddingTop: 0,
            [theme.breakpoints.down(1441)]: {
              height: '320px',
              maxWidth: '600px',
            },
          }}
          divider={<Divider />}
          direction='row'
        >
          {renderFilterList()}
          <Box
            sx={{
              maxWidth: '360px',
              minWidth: '360px',
              height: '477px',
              overflowY: 'auto',
              position: 'relative',
              overflowX: 'hidden',
              [theme.breakpoints.down(1441)]: {
                height: '320px',
                maxWidth: '300px',
                minWidth: '300px',
              },
            }}
          >
            {renderFilter()}
          </Box>
        </Stack>
        <Stack
          sx={{ mt: 3, position: 'relative', display: 'flex' }}
          justifyContent='space-between'
          direction='row'
          useFlexGap
        >
          <ButtonV3
            variant='outlined'
            onClick={resetFilters}
            sx={{
              flex: 1,
              fontFamily: 'Poppins',
              '@media (max-width: 1440px)': {
                fontSize: '12px',
                height: '30px'
              },
              '&:hover': {
                backgroundColor: '#E0E9FA',
                border: '1px solid #D0D5DD',
              },
            }}
          >
            Reset
          </ButtonV3>
          <ButtonV3
            variant='contained'
            onClick={() => {
              setApplyFilter(true);
              setApplyRole(false);
            }}
            disabled={
              checked?.length > 0 ||
                filterModel !== '' ||
                filterOcpp !== '' ||
                filterStatus?.length > 0 ||
                filterTenant !== '' ||
                qrFlag !== '' ||
                connectorType?.length > 0 ||
                connectors !== ''
                ? false
                : true
            }
            sx={{
              flex: 1,
              background: '#3D3AD3',
              color: '#FFFFFF',
              position: 'relative',
              left: '8px',
              border: 'none',
              boxShadow: 'none',
              fontFamily: 'Poppins',
              height: '40px',
              '@media (max-width: 1440px)': {
                fontSize: '12px',
                height: '30px'
              },
              '&:hover': {
                backgroundColor: '#3D3AD3',
                border: 'none',
                opacity: 0.5,
                boxShadow: 'none',
              },
            }}
          >
            Apply Filter
          </ButtonV3>
        </Stack>
      </>
    );
  };
  